module.exports = __webpack_public_path__ + "kudos_34.svg?7f21eb64a8e5d351393a3c4f7302a1d7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_34.svg
// module id = 133
// module chunks = 0